// Dependencies
import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import { Link } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// Style
import '../../css/app.css';

// Images
import logo from '../../sass/images/logo_navbar.png';
import icono1 from '../../sass/images/menuMovil/icon_feather_home.svg';
import icono2 from '../../sass/images/menuMovil/member_card.svg';
import icono3 from '../../sass/images/menuMovil/icon_ionic_ios_document.svg';
import icono4 from '../../sass/images/menuMovil/icon_feather_book_open.svg';

// Hooks
import useLanguage from '../hooks/useLanguage';
import useTermsAndConditions from '../hooks/useTermsAndConditions';
import useToggleMenu from '../hooks/useToggleMenu';

function Menu(props) {
  const { t } = props;
  const { handleChangeToggle, scrolly } = useToggleMenu();
  const { isEnglish, changeLanguage, locale } = useLanguage();
  const { termAndCondition, termPoliticsPrivate } = useTermsAndConditions();

  return (
    <Navbar
      className={`navBarMenu ${scrolly ? 'scroll-nav' : ''}`}
      expand="lg"
      onToggle={(toggle) => handleChangeToggle(toggle)}
    >
      <Link to={`/${locale}/${t('routers:Home')}`}>
        <img src={logo} className="logoMenu" alt={t('alt:logo')} />
      </Link>
      <Nav className="mr-auto mobile ">
        <Link
          to={`/${locale}/${t('routers:Login')}`}
          className="mobile loginButton loginButtonMobile"
        >
          {t('login-txt')}
        </Link>
      </Nav>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto">
          <Link to={`/${locale}/${t('routers:Plans')}`} className="desktop membership textButton ">
            {t('plans-txt')}
          </Link>
          <Link
            to={`/${locale}/${t('routers:Register')}`}
            className="desktop membershipR textButton"
          >
            {t('register-title')}
          </Link>
          <Link to={`/${locale}/${t('routers:Login')}`} className="desktop loginButton">
            {t('login-txt')}
          </Link>
          <button
            type="button"
            onClick={() => {
              changeLanguage('en');
            }}
            className={
              isEnglish ? 'desktop leguajeButton langEn' : 'desktop leguajeButton langEnOff'
            }
          >
            Eng
          </button>

          <button
            type="button"
            onClick={() => {
              changeLanguage('es');
            }}
            className={
              !isEnglish
                ? 'desktop leguajeButton second langEs'
                : 'desktop leguajeButton second langEsOff'
            }
          >
            Esp
          </button>
          {/* MOVIL */}
          <div className="button_language">
            <button
              type="button"
              onClick={() => {
                changeLanguage('en');
              }}
              className={
                isEnglish ? 'mobile leguajeButton langEn' : 'mobile leguajeButton langEnOff'
              }
            >
              Eng
            </button>

            <button
              type="button"
              onClick={() => {
                changeLanguage('es');
              }}
              className={
                !isEnglish
                  ? 'mobile leguajeButton second langEs'
                  : 'mobile leguajeButton second langEsOff'
              }
            >
              Esp
            </button>
          </div>
          <div className="mobilecontent">
            <Link to={`/${locale}/`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={icono1} alt={t('alt:home')} />
              </span>
              <span className="textmenumobile">{t('home')}</span>
            </Link>
            <Link to={`/${locale}/${t('routers:Plans')}`} className="mobile x2">
              <span className="iconmenumobile">
                <img src={icono2} alt={t('alt:plans')} />
              </span>
              <span className="textmenumobile">{t('plans-txt')}</span>
            </Link>
            <Link
              to={`/${locale}/${t('routers:Terms')}/${termAndCondition.slug}`}
              className="mobile x2"
            >
              <span className="iconmenumobile">
                <img src={icono3} alt={t('alt:termAndCondition')} />
              </span>
              <span className="textmenumobile">{t('terms-condition')}</span>
            </Link>
            <Link
              to={`/${locale}/${t('routers:Terms')}/${termPoliticsPrivate.slug}`}
              className="mobile x2"
            >
              <span className="iconmenumobile">
                <img src={icono4} alt={t('alt:authorizationData')} />
              </span>
              <span className="textmenumobile border-none">{t('terms-data')}</span>
            </Link>
            <div className="buttonMobilex2">
              <Link to={`/${locale}/${t('routers:Login')}`} className="mobile  loginMobile">
                {t('login-txt')}
              </Link>
              <br />
              <Link to={`/${locale}/${t('routers:Register')}`} className="mobile  register_mobile">
                {t('register-title')}
              </Link>
            </div>
          </div>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

Menu.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['menu', 'routers', 'alt'])(Menu);
